import { OrderFormValue } from './index';
var OrderFormMisc = /*@__PURE__*/ (function () {
    function OrderFormMisc() {
    }
    OrderFormMisc.prototype.getEvn = function () {
        return this.misc_evn;
    };
    OrderFormMisc.prototype.setEvn = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(2)
            .setMax(36)
            .setMand('Y')
            .setType('selection[Ja|Off|Zielrufnummer verk\u00fcrzt|Zielrufnummer vollst\u00e4ndig]');
        this.misc_evn = formValue;
        return this;
    };
    OrderFormMisc.prototype.getInformation = function () {
        return this.misc_auskunft;
    };
    OrderFormMisc.prototype.setInformation = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(2)
            .setMax(20)
            .setMand('Y')
            .setType('selection[Off|Eintrag und Auskunft]');
        this.misc_auskunft = formValue;
        return this;
    };
    OrderFormMisc.prototype.getVONumber = function () {
        return this.misc_vo_nr;
    };
    OrderFormMisc.prototype.setVONumber = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(1)
            .setMax(10)
            .setMand('Y')
            .setType('numeric');
        this.misc_vo_nr = formValue;
        return this;
    };
    OrderFormMisc.prototype.getReverseSearch = function () {
        return this.misc_reverse_search;
    };
    OrderFormMisc.prototype.setReverseSearch = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(2)
            .setMax(20)
            .setMand('Y')
            .setType('selection[Eintrag und Auskunft|Off]');
        this.misc_reverse_search = formValue;
        return this;
    };
    OrderFormMisc.prototype.getProvideMsisdn = function () {
        return this.misc_provide_msisdn;
    };
    OrderFormMisc.prototype.setProvideMsisdn = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(3)
            .setMax(5)
            .setMand('N')
            .setType('selection[Off|keine]');
        this.misc_provide_msisdn = formValue;
        return this;
    };
    OrderFormMisc.prototype.getAcceptConditions = function () {
        return this.misc_accept_conditions;
    };
    OrderFormMisc.prototype.setAcceptConditions = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(3)
            .setMax(5)
            .setMand('Y')
            .setType('selection[Ja|Off]');
        this.misc_accept_conditions = formValue;
        return this;
    };
    return OrderFormMisc;
}());
export { OrderFormMisc };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/order/order.form-misc.ts
// module id = null
// module chunks = 